import React, { useId } from "react";

// Logo maison : silhouette de poulet tracée depuis la référence fournie,
// remplie avec le même dégradé (--secondary → --primary) que le texte
// "PouletDirect" à côté, pour suivre le thème automatiquement.
const ChickenLogo = ({ size = 28, className, fill }) => {
  const gradientId = useId();
  // `fill` permet un remplissage uni (ex. "white") plutôt que le dégradé —
  // nécessaire quand le logo est posé sur un fond déjà dégradé (avatar de
  // l'assistant du tour), où le dégradé sur dégradé le rend illisible.
  return (
  <svg
    width={size}
    height={size}
    viewBox="0 0 140 141"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    {!fill && (
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="var(--secondary)" />
          <stop offset="100%" stopColor="var(--primary)" />
        </linearGradient>
      </defs>
    )}
    <g transform="translate(12, 12) translate(-30.000000, 155.867754) scale(0.100000, -0.100000)" fill={fill || `url(#${gradientId})`} stroke="none">
      <path d="M862 1525 c-26 -32 -31 -35 -56 -25 -58 22 -103 0 -120 -57 -8 -25
        15 -77 41 -92 15 -8 13 -13 -17 -50 -71 -82 -130 -176 -130 -206 0 -7 -23 -21
        -52 -31 -29 -11 -69 -37 -92 -59 -42 -40 -136 -169 -136 -184 0 -9 163 -81
        182 -81 6 0 7 -7 4 -17 -15 -37 -29 -150 -22 -176 9 -37 50 -63 79 -50 19 9
        24 6 39 -28 28 -64 105 -96 161 -68 40 21 77 62 77 87 0 21 4 23 24 18 75 -19
        230 -27 313 -17 126 15 179 36 233 90 58 58 75 112 67 219 -7 97 -59 316 -92
        386 -14 29 -25 68 -25 87 0 41 -24 79 -50 79 -12 0 -22 12 -30 35 -15 46 -47
        75 -81 75 -20 0 -33 9 -49 34 -28 46 -55 54 -90 27 l-28 -20 -37 29 c-50 40
        -77 38 -113 -5z"/>
    </g>
  </svg>
  );
};

export default ChickenLogo;
